/**
 * Quand demander si l'accident a eu lieu en agglomeration.
 *
 * La question ne se pose que si un proces-verbal est fourni : c'est lui qui porte
 * l'information, sans lui personne n'a de source pour y repondre. Et des lors
 * qu'elle est posee, un lieu saisi la rend obligatoire - elle precise ce lieu,
 * une precision a moitie donnee ne vaut rien.
 *
 * L'obligation ne survit jamais a la disparition de la question : sans PV, le
 * champ n'est pas a l'ecran, rien ne peut donc etre exige.
 */
export const regleAgglomeration = ({ pvEtabli, lieuAccident } = {}) => {
  const visible = !!pvEtabli;
  const lieuRenseigne = String(lieuAccident ?? '').trim().length > 0;

  return { visible, obligatoire: visible && lieuRenseigne };
};
